import { Link } from 'gatsby';
import { GatsbyImage, getImage } from 'gatsby-plugin-image';
import React from 'react';
import styled from 'styled-components';
import GlobalStyles from '../styles/GlobalStyles';
import formatMoney from '../utils/formatMoney';

const ItemWrapper = styled.div`
  margin: 0 8px;
  min-width: 300px;
  max-width: 500px;
  /* padding: 8px; */
  /* border: 2px solid var(--dark-accent);
  border-radius: 16px; */
  /* box-shadow: 4px -2px 4px var(--shadow); */
  overflow: hidden;
`;

const ItemDescriptionWrapper = styled.div`
  display: inline-block;
  padding: 20px 0px 0px 8px;
  height: 8rem;
  width: 72%;
`;

const ItemPriceWrapper = styled.div`
  display: inline-block;
  height: 8rem;
  width: 25%;
  text-align: right;
`;

const ItemPictureWrapper = styled.div`
  min-width: 300px;
  max-width: 500px;
  background-color: var(--light-accent);
  border-radius: 8px;
`;

function ItemCard({ item }) {
  const image = getImage(item.image.asset.gatsbyImageData);
  return (
    <ItemWrapper>
      <GlobalStyles />
      <Link to={`/browse/${item.slug.current}`}>
        <ItemPictureWrapper>
          <GatsbyImage
            image={image}
            alt={`A picture of a ${item.name}`}
            style={{ borderRadius: 2 }}
          />
        </ItemPictureWrapper>
        <ItemDescriptionWrapper>{item.name}</ItemDescriptionWrapper>
        <ItemPriceWrapper>{formatMoney(item.price)}</ItemPriceWrapper>
      </Link>
    </ItemWrapper>
  );
}

export default function ItemsList({ items }) {
  console.log(items);
  return (
    <>
      {items.map(item => (
        <ItemCard key={item.id} item={item} />
      ))}
    </>
  );
}
